import { Route, useHistory } from "react-router";

import { FeedbackDetailsPage, FeedbackReportsPage } from "pages/feedback";
import useFeedbacks from "pages/feedback/useFeedbacks";

import User from "types/User";

import { linkToFeedbackReport } from "./links";

type Props = {
  user: User;
};
export default function FeedbackRoute({ user }: Props) {
  const history = useHistory();
  const handleClose = () => history.goBack();
  const { feedbacks, handleToggleResolvedClick, fetchFeedbackById } =
    useFeedbacks(user);

  return (
    <>
      <Route path={linkToFeedbackReport()}>
        <FeedbackDetailsPage
          feedbacks={feedbacks}
          handleToggleResolvedClick={handleToggleResolvedClick}
          handleClose={handleClose}
          fetchFeedbackById={fetchFeedbackById}
        />
      </Route>

      <FeedbackReportsPage
        feedbacks={feedbacks}
        handleClose={handleClose}
        handleToggleResolvedClick={handleToggleResolvedClick}
        handleFeedbackItemClick={(id: string) =>
          history.push(linkToFeedbackReport(id))
        }
      />
    </>
  );
}
